import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getAllKPIs } from '@src/services/Admin';
import Loader from '../../components/Loader';
import KPICard from '../../components/KPICard';
import { APP } from '../../services/Constants';

const appLabel = (key) => (
  `${APP[key]?.emoji || '👯'} ${APP[key]?.name || 'Buddies (All apps)'}`
);

function Stats() {
  const { isLoading, data } = useQuery(
    ['getAllKPIs'],
    getAllKPIs,
    { cacheTime: 0 },
  );
  let total;
  if (data) {
    total = {
      mrr: data.reduce((t, item) => t + item.mrr, 0),
      currentFreeTrials: data
        .reduce((array, item) => [
          ...array,
          ...item.freeTrials.currentPeriod.teamIds,
          ...(item.freeTrials.currentPeriod.tenantIds || []),
        ], [])
        .filter((elem, index, array) => array.indexOf(elem) === index)
        .length,
      currentFreeTrialsGT30: data
        .reduce((array, item) => [
          ...array,
          ...item.freeTrials.currentPeriod.items.filter((t) => t.count >= 30).map((t) => t.id),
        ], [])
        .filter((elem, index, array) => array.indexOf(elem) === index)
        .length,
      previousFreeTrials: data
        .reduce((array, item) => [
          ...array,
          ...item.freeTrials.previousPeriod.teamIds,
          ...(item.freeTrials.previousPeriod.tenantIds || []),
        ], [])
        .filter((elem, index, array) => array.indexOf(elem) === index)
        .length,
      previousFreeTrialsGT30: data
        .reduce((array, item) => [
          ...array,
          ...item.freeTrials.previousPeriod.items.filter((t) => t.count >= 30).map((t) => t.id),
        ], [])
        .filter((elem, index, array) => array.indexOf(elem) === index)
        .length,
    };
  }
  return (
    <div id="Stats">
      {isLoading && <Loader />}
      {data && (
        <>
          <div>
            <div className="AppName">∑ Total</div>
            <div className="CardList">
              <KPICard number={total.mrr} title="$MRR" />
              <KPICard
                number={total.currentFreeTrials}
                afterNumber={` (${total.currentFreeTrialsGT30}+${total.currentFreeTrials - total.currentFreeTrialsGT30})`}
                title="Free Trials"
                subTitle={`${data[0].freeTrials.currentPeriod.start.split('T')[0]} → ${data[0].freeTrials.currentPeriod.end.split('T')[0]}`}
              />
              <KPICard
                number={total.previousFreeTrials}
                afterNumber={` (${total.previousFreeTrialsGT30}+${total.previousFreeTrials - total.previousFreeTrialsGT30})`}
                title="Free Trials"
                subTitle={`${data[0].freeTrials.previousPeriod.start.split('T')[0]} → ${data[0].freeTrials.previousPeriod.end.split('T')[0]}`}
              />
            </div>
          </div>
          {data.map((item) => (
            <div key={item.app}>
              <div className="AppName">{appLabel(item.app)}</div>
              <div className="CardList">
                <KPICard number={item.mrr} title="$MRR" />
                <KPICard
                  number={item.freeTrials.currentPeriod.items.length}
                  title="Free Trials"
                  afterNumber={` (${item.freeTrials.currentPeriod.items.filter((i) => i.count >= 30).length}+${item.freeTrials.currentPeriod.items.filter((i) => i.count < 30).length})`}
                  subTitle={`${item.freeTrials.currentPeriod.start.split('T')[0]} → ${item.freeTrials.currentPeriod.end.split('T')[0]}`}
                />
                <KPICard
                  number={item.freeTrials.previousPeriod.items.length}
                  title="Free Trials"
                  afterNumber={` (${item.freeTrials.previousPeriod.items.filter((i) => i.count >= 30).length}+${item.freeTrials.previousPeriod.items.filter((i) => i.count < 30).length})`}
                  subTitle={`${item.freeTrials.previousPeriod.start.split('T')[0]} → ${item.freeTrials.previousPeriod.end.split('T')[0]}`}
                />
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}

export default Stats;
